import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Troubleshooting from "./pages/Troubleshooting";
import ArticlePage from "./pages/ArticlePage";
import Services from "./pages/Services";
import RequestService from "./pages/RequestService";
import LocalServices from "./pages/LocalServices";
import SpareParts from "./pages/SpareParts";
import Gallery from "./pages/Gallery";
import Jobs from "./pages/Jobs";
import Insurance from "./pages/Insurance";
import InsuranceStrip from "./components/InsuranceStrip";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AIReceptionist from "./components/AIReceptionist";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { trackVisit } from "./lib/api";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <Navbar />
      {children}
      <InsuranceStrip />
      <Footer />
      <AIReceptionist />
    </div>
  );
}

function App() {
  useEffect(() => {
    trackVisit();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/troubleshooting" element={<PublicLayout><Troubleshooting /></PublicLayout>} />
          <Route path="/troubleshooting/:slug" element={<PublicLayout><ArticlePage /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/request" element={<PublicLayout><RequestService /></PublicLayout>} />
          <Route path="/local-services" element={<PublicLayout><LocalServices /></PublicLayout>} />
          <Route path="/spare-parts" element={<PublicLayout><SpareParts /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/jobs" element={<PublicLayout><Jobs /></PublicLayout>} />
          <Route path="/insurance" element={<PublicLayout><Insurance /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
